/**
 * Compact a count for a button label (1.2k / 3M) so a large value can't
 * overrun the space next to its glyph. Values under 1000 render every digit.
 * Mirrors mobile/lib/util/formatCompactCount.ts — keep the two in sync.
 */
export function formatCompactCount(n: number): string {
  if (n < 1000) return `${n}`;
  for (const { div, suffix } of [
    { div: 1_000, suffix: "k" },
    { div: 1_000_000, suffix: "M" },
    { div: 1_000_000_000, suffix: "B" },
  ]) {
    const value = n / div;
    // A value that rounds up to 1000 belongs in the next-larger unit
    // (999,950 → "1M", not "1000k"; 999,999,950 → "1B", not "1000M") — skip on.
    if (Math.round(value) >= 1000) continue;
    // One decimal under 10 (1.2k), but never a bare ".0" (1k, not 1.0k).
    return value >= 10
      ? `${Math.round(value)}${suffix}`
      : `${value.toFixed(1).replace(/\.0$/, "")}${suffix}`;
  }
  // Beyond the billion unit — render in billions.
  return `${Math.round(n / 1_000_000_000)}B`;
}
